import { render } from "./SiteApp.vue?vue&type=template&id=4b17f5bf"
import script from "./SiteApp.vue?vue&type=script&setup=true&lang=js"
export * from "./SiteApp.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/SiteApp.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4b17f5bf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4b17f5bf', __exports__)) {
    api.reload('4b17f5bf', __exports__)
  }
  
  module.hot.accept("./SiteApp.vue?vue&type=template&id=4b17f5bf", () => {
    api.rerender('4b17f5bf', render)
  })

}


export default __exports__